import React, { useEffect, useState } from 'react';
import {
    TextField,
    DialogTitle,
    DialogContentText,
    DialogContent,
    DialogActions,
    Dialog,
    Button,
    Stack,
    InputBase,
    Paper
} from '@mui/material';
import { ValidateEmail } from '../../../Utils';
import toast from 'react-simple-toasts';
import { messages } from '../../../messages';
import { createContact, createContactGroup } from '../../../paymentRequest';
import { hideApiLoader, showApiLoader } from '../../../../redux/tool-webjam/actions';
import { useDispatch } from 'react-redux';
import ContactDropMenu from './ContactDropMenu';
import PModalFooter from '../helperComponent/PModalFooter';
import { ct } from '../../../../constant-Utils';




function CreateGroup(props) {
    const dispatch = useDispatch();

    const [open, setOpen] = useState(false);

    const [formValues, setFormValues] = useState({ group_name: "", users: [] })

    const { title, handleGroupClose } = props;

    const handleClose = (type) => {
        setOpen(false);
        handleGroupClose(type)
    };

    useEffect(() => {
        setOpen(true);
    }, [])

    let handleInputChange = (e) => {
        setFormValues({
            ...formValues,
            group_name: e.target.value
        });
    }

    const handleFormSubmit = () => {
        let data = formValues;
        data.group_name = data.group_name.trim()
        if (!data.group_name) {
            toast(ct("messages.contactGroupRequired","messages"));
        } else if (!data.users.length) {
            toast(ct("messages.contactUserRequired","messages"));
        } else {
            dispatch(showApiLoader())
            createContactGroup(formValues).then(async res => {
                dispatch(hideApiLoader())
                if (res.status == 1) {
                    handleGroupClose(false, 1)
                    let msg = await dynamicMessageLocale(res.data.message);
                    toast(msg)
                    setFormValues([{ name: "", email: "" }])
                } else if (res.error == 400 || res.error == 406) {
                    if (res.data?.message) {
                        let msg = await dynamicMessageLocale(res.data.message);
                        toast(msg)
                    } else {
                        toast(ct("rta-trmc.dashboard.subscription.failed"))
                    }
                }
            })
        }
    }

    const selectedEmail = (emails) => {

        let data = Object.values(emails);
        console.log("receiving at main po ", data)
        setFormValues({
            ...formValues,
            users: data
        });
    }

    return (
        <div>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                fullWidth={true}
                className="welcome-modal-pop"
            >
                <DialogTitle id="alert-dialog-title">
                    {title}
                </DialogTitle>
                <DialogContent>
                    <TextField
                        label="Group name"
                        variant="filled"
                        onChange={(e) => handleInputChange(e)}
                        className="payment-input"
                        sx={{
                            width: "100%"
                        }}
                    />
                    <ContactDropMenu
                        selectedEmail={selectedEmail}
                        customStyle={{
                            mb: 3,
                            mt: 3,
                            width: "100%",
                            p: 0
                        }}
                        width={"100%"}
                    />
                </DialogContent>
                <PModalFooter
                    submit={() => handleFormSubmit()}
                    cancel={() => handleClose(false)}
                />
            </Dialog>
        </div>
    );
}

export default CreateGroup;
